<template>
  <div class="dict-layout-container container-fluid py-3">
    <div class="dict-layout-wrapper">
      <!-- Left Sidenav Rail / Drawer -->
      <div class="dict-sidebar-pane" :class="{ 'is-collapsed': isCollapsed }">
        <side-nav
          :active-item="itemName"
          :collapsed="isCollapsed"
          @toggle-collapse="isCollapsed = !isCollapsed"
          @toggle-dictionary="handleItemChange"
        />
      </div>

      <!-- Main Content Workspace -->
      <div class="dict-content-pane">
        <!-- Top Workspace Bar -->
        <div class="dict-topbar card mb-3">
          <div class="card-body p-2 px-3 d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div class="d-flex align-items-center gap-2">
              <button
                type="button"
                class="btn action-btn action-btn--muted d-inline-flex d-lg-none"
                title="Menyu"
                @click="isCollapsed = !isCollapsed"
              >
                <i class="bi bi-list"></i>
              </button>
              <div class="dict-active-icon-box" :class="activeItemMeta.colorClass">
                <i :class="activeItemMeta.icon"></i>
              </div>
              <div class="dict-active-meta">
                <div class="d-flex align-items-center gap-2">
                  <h6 class="mb-0 font-weight-bolder">{{ activeItemMeta.label }}</h6>
                  <span class="dict-category-pill">{{ activeItemMeta.category }}</span>
                </div>
              </div>
            </div>

            <!-- Quick Selector Dropdown -->
            <div class="d-flex align-items-center gap-2">
              <el-select
                v-model="itemName"
                class="dict-quick-select d-none d-sm-inline-block"
                style="width: 240px;"
                placeholder="Seçin"
              >
                <el-option
                  v-for="item in allItems"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                  <div class="d-flex align-items-center gap-2">
                    <i :class="item.icon" class="text-primary"></i>
                    <span>{{ item.label }}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <!-- Dictionary Content View -->
        <div class="dict-view-container">
          <Conditions v-if="itemName === 'Conditions'" />
          <Illness v-if="itemName === 'Illness'" />
          <Symptoms v-if="itemName === 'Symptoms'" />
          <RejectType v-if="itemName === 'RejectType'" />
          <ComplaintTemplate v-if="itemName === 'ComplaintTemplate'" />
          <ExceptionType v-if="itemName === 'ExceptionType'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideNav from "./Components/SideNav.vue";
import Conditions from "./Conditions/Main.vue";
import Illness from "./Illness/Main.vue";
import Symptoms from "./Symptoms/Main.vue";
import RejectType from "./RejectType/Main.vue";
import ComplaintTemplate from "./ComplaintTemplate/Main.vue";
import ExceptionType from "./ExceptionType/Main.vue";

export default {
  name: "DictionaryMain",
  components: {
    SideNav,
    Conditions,
    Illness,
    Symptoms,
    RejectType,
    ComplaintTemplate,
    ExceptionType
  },
  data() {
    return {
      itemName: "Conditions",
      isCollapsed: false
    };
  },
  computed: {
    allItems() {
      return [
        {
          key: "Conditions",
          label: "Şərtlər",
          icon: "bi bi-file-earmark-text",
          category: "Əsas Bölmələr",
          colorClass: "icon--primary"
        },
        {
          key: "Illness",
          label: "Xəstəliklər",
          icon: "bi bi-heart-pulse",
          category: "Əsas Bölmələr",
          colorClass: "icon--danger"
        },
        {
          key: "Symptoms",
          label: "Simptomlar",
          icon: "bi bi-activity",
          category: "Əsas Bölmələr",
          colorClass: "icon--warning"
        },
        {
          key: "RejectType",
          label: "İmtina səbəbi",
          icon: "bi bi-x-circle",
          category: "Qaydalar və Şablonlar",
          colorClass: "icon--danger"
        },
        {
          key: "ComplaintTemplate",
          label: "Şikayətlər",
          icon: "bi bi-exclamation-triangle",
          category: "Qaydalar və Şablonlar",
          colorClass: "icon--warning"
        },
        {
          key: "ExceptionType",
          label: "İstisnalar",
          icon: "bi bi-shield-slash",
          category: "Qaydalar və Şablonlar",
          colorClass: "icon--dark"
        }
      ];
    },
    activeItemMeta() {
      const found = this.allItems.find((i) => i.key === this.itemName);
      return (
        found || {
          key: this.itemName,
          label: this.itemName,
          icon: "bi bi-journal-text",
          category: "Soraqçalar",
          colorClass: "icon--primary"
        }
      );
    }
  },
  methods: {
    handleItemChange(key) {
      this.itemName = key;
    }
  }
};
</script>

<style scoped lang="scss">
.dict-layout-container {
  width: 100%;
}

.dict-layout-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  width: 100%;
}

.dict-sidebar-pane {
  flex: 0 0 270px;
  width: 270px;
  min-width: 270px;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);

  &.is-collapsed {
    flex: 0 0 58px;
    width: 58px;
    min-width: 58px;
  }
}

.dict-content-pane {
  flex: 1 1 auto;
  min-width: 0;
}

.dict-topbar {
  border-radius: var(--app-radius, 12px);
  border: 1px solid var(--app-border, #e2e8f0);
  box-shadow: var(--app-shadow, 0 1px 3px rgba(0, 0, 0, 0.05));
  background: var(--app-surface, #ffffff);
}

.dict-active-icon-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 7px;
  font-size: 1rem;
  flex-shrink: 0;

  &.icon--primary {
    color: var(--bs-info, #0b4f9c);
    background: color-mix(in srgb, var(--bs-info, #0b4f9c) 14%, var(--app-surface, #ffffff));
  }
  &.icon--danger {
    color: #dc2626;
    background: color-mix(in srgb, #dc2626 14%, var(--app-surface, #ffffff));
  }
  &.icon--info {
    color: #0284c7;
    background: color-mix(in srgb, #0284c7 14%, var(--app-surface, #ffffff));
  }
  &.icon--success {
    color: #059669;
    background: color-mix(in srgb, #059669 14%, var(--app-surface, #ffffff));
  }
  &.icon--warning {
    color: #d97706;
    background: color-mix(in srgb, #d97706 14%, var(--app-surface, #ffffff));
  }
  &.icon--teal {
    color: #0d9488;
    background: color-mix(in srgb, #0d9488 14%, var(--app-surface, #ffffff));
  }
  &.icon--purple {
    color: #7c3aed;
    background: color-mix(in srgb, #7c3aed 14%, var(--app-surface, #ffffff));
  }
  &.icon--indigo {
    color: #4f46e5;
    background: color-mix(in srgb, #4f46e5 14%, var(--app-surface, #ffffff));
  }
  &.icon--dark {
    color: #475569;
    background: color-mix(in srgb, #475569 14%, var(--app-surface, #ffffff));
  }
}

.dict-active-meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dict-category-pill {
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: var(--app-surface-muted, #f1f5f9);
  color: var(--app-text, #64748b);
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.dict-quick-select :deep(.el-input__wrapper) {
  height: 32px !important;
  min-height: 32px !important;
  border-radius: 6px !important;
}

.dict-view-container {
  width: 100%;

  :deep(.row) {
    margin: 0 !important;
    padding: 0 !important;
  }
}

@media (max-width: 991.98px) {
  .dict-layout-wrapper {
    flex-direction: column;
  }

  .dict-sidebar-pane {
    width: 100% !important;
    min-width: 100% !important;
    flex: 1 1 auto;
  }
}

[data-theme="dark"] {
  .dict-topbar {
    background: #1c232b;
    border-color: #2e3846;
  }

  .dict-category-pill {
    background: #252f3b;
    color: #94a3b8;
  }
}
</style>